var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea"},[_c('Editor',{ref:"editor",attrs:{"initialValue":_vm.value,"options":_vm.options,"previewStyle":"tab","initialEditType":"wysiwyg","height":`${_vm.height.includes('%') ? _vm.height : `${_vm.height}px`}`},on:{"change":_vm.emit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }